export enum StorageKey {
	productColumns = 'ProductColumns',
	productPagination = 'ProductPagination',
	lockPagination = 'ProductPagination',

	orderPagination = 'OrderPagination',
	orderSort = 'OrderSort',

	fixedPricePagination = 'FixedPricePagination',
	fixedPriceSort = 'FixedPriceSort',
	importConfigPagination = 'ImportConfig',
}
